const generic = {
  action: "generic_progress_step",
  labels: {
    videoButton: "hero:video-button",
    copyLink: "mobile:copy-link",
    loginBanner: "login-banner:signup",
  },
};

export default generic;
